<div onsip-grid-placement-shelf>
  <div class="first-column">
    <section>
      <div class="mat-body-1 m-b-12">Mailbox owner</div>
      <div>{{ getOwnerDisplayName() }}</div>
    </section>
    <section>
      <div class="mat-body-1 m-b-12">Mailbox name</div>
      <div [attr.data-cy]="E2eLocators.ADMIN_VOICEMAIL_VIEW_SHELVE_MAILBOX_NAME">
        {{ voicemailBasicInfo.mailboxName ? voicemailBasicInfo.mailboxName : "n/a" }}
      </div>
    </section>
    <section>
      <div class="mat-body-1 m-b-12">Mailbox number</div>
      <div [attr.data-cy]="E2eLocators.ADMIN_VOICEMAIL_VIEW_SHELVE_MAILBOX_NUMBER">
        {{ voicemailBasicInfo.mailboxNumber ? voicemailBasicInfo.mailboxNumber : "n/a" }}
      </div>
    </section>
    <section>
      <div class="mat-body-1 m-b-12">{{ "ONSIP_I18N.MAILBOX_PASSWORD_PIN" | translate }}</div>
      <div>{{ voicemailBasicInfo.mailboxPin ? voicemailBasicInfo.mailboxPin : "n/a" }}</div>
    </section>
  </div>

  <div class="second-column">
    <section>
      <div class="mat-body-1 m-b-12">Notification email</div>
      <div>
        {{ voicemailBasicInfo.notificationEmail ? voicemailBasicInfo.notificationEmail : "none" }}
      </div>
    </section>
    <section>
      <div class="mat-body-1 m-b-12">Attach message as a .wav file</div>
      <div>{{ voicemailBasicInfo.attachAsWav ? "Yes" : "No" }}</div>
    </section>
    <section>
      <div class="mat-body-1 m-b-12">Delete message after sending</div>
      <div>{{ voicemailBasicInfo.deleteAfterSending ? "Yes" : "No" }}</div>
    </section>
    <section>
      <div class="mat-body-1 m-b-12">Message waiting notification</div>
      <div>{{ getMwiDisplayName() }}</div>
    </section>
  </div>
</div>

<div class="page-view-controls">
  <button
    mat-flat-button
    class="toggle-button"
    color="primary"
    (click)="togglePanel()"
    [attr.data-cy]="E2eLocators.ADMIN_VOICEMAIL_VIEW_SHELVE_EDIT"
  >
    {{ "ONSIP_I18N.EDIT_INFO" | translate }}
  </button>
</div>
